import { DomesticAddress } from '@shared/types'
import { COMMON_PLACEHOLDER } from '@ui-components/global/constants'
import { JSX } from 'react'

interface AddressProps {
  address: Partial<DomesticAddress>
}

export const DomesticAddressFields = ({ address }: AddressProps): JSX.Element => {
  return (
    <>
      <span>
        {address.street ?? COMMON_PLACEHOLDER}
        <br />
      </span>
      <span>
        {address.postalCode ?? COMMON_PLACEHOLDER} {address.postOffice ?? COMMON_PLACEHOLDER}
        <br />
      </span>
      {address.countryName && (
        <span>
          {address.countryName}
          <br />
        </span>
      )}
    </>
  )
}
